import React from "react";
import styled from "styled-components";
import { useFormContext } from "react-hook-form";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 6px;
`;

const Group = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const TextArea = styled.textarea`
  width: 100%;
  max-width: 500px;
  background: #f8fafc;
  border: 1.5px solid #e2e8f0;
  border-radius: 10px;
  padding: 14px 16px;
  font-size: 15px;
  box-sizing: border-box;
  color: #0f172a;
  outline: none;
  transition: all 0.2s ease-in-out;
  &:focus {
    background: #ffffff;
    border-color: #13cae9;
    box-shadow: 0 0 0 4px rgba(19, 202, 233, 0.1);
  }
  @media (max-width: 768px) {
    max-width: 100%;
  }
`;

const Label = styled.label`
  align-self: start;
  font-weight: 600;
  font-size: 14px;
  text-transform: capitalize;
  color: #334155;
`;

const Error = styled.p`
  color: #ef4444;
  font-size: 13px;
  margin-top: 4px;
`;

export default function TextAreaInputGroup(props) {
  const { register } = useFormContext();
  return (
    <Container>
      <Group>
        <Label htmlFor={props.label}>{props.label}</Label>
        <TextArea
          id={props.label}
          {...props.textArea}
          {...register(props.name)}
          cols="30"
          rows="5"
        />
      </Group>
      {props.error ? <Error>{props.error.message}</Error> : null}
    </Container>
  );
}
